import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Video = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.87906 4H20.1109H20.1209C20.8806 4 22 4.43 22 5.61V18.39C22 19.04 21.5002 20 20.1209 20H3.87906C3.11944 20 2 19.57 2 18.39V5.61C2 4.96 2.49975 4 3.87906 4ZM20.1109 18.76C20.6007 18.76 20.7306 18.55 20.7306 18.38L20.7406 18.37V5.6C20.7406 5.25 20.1109 5.24 20.1109 5.24H3.86907C3.37931 5.24 3.24938 5.45 3.24938 5.62V18.4C3.24938 18.75 3.87906 18.76 3.87906 18.76H20.1109ZM10.8956 8.58001L15.4233 10.84C15.7332 11 15.963 11.26 16.073 11.59C16.1829 11.92 16.1629 12.27 16.003 12.58C15.8831 12.83 15.6732 13.04 15.4233 13.16L10.9056 15.42C10.7257 15.51 10.5258 15.56 10.3259 15.56C10.1859 15.56 10.046 15.53 9.91607 15.49C9.58624 15.38 9.31637 15.15 9.16645 14.84C9.07649 14.66 9.02652 14.46 9.02652 14.26V9.74001C9.02652 9.03001 9.60623 8.45001 10.3159 8.45001C10.5158 8.45001 10.7157 8.49001 10.8956 8.58001ZM10.3459 9.70001L10.2859 14.26L10.3459 14.3L14.8636 12.04L10.3459 9.70001Z"
    />
  </svg>
)

export default withDefaultStyles(Video)
